import React from 'react'
import PropTypes from 'prop-types';
import PartsRouter from './PartsRouter';
import Page from 'components/Page';
import InfoBar from "components/complex/infobar/InfoBar";
import StageBar from "components/complex/stagebar/StageBar";
import {makeStyles} from "@material-ui/styles";


const useStyles = makeStyles(theme => ({
	content: {
		padding: theme.spacing(2)
	}
}));

function StepperPages(
	{
		match
	}) {
	const classes = useStyles();

	return (

		<Page>
			<InfoBar />
			<StageBar />
			<div className={classes.content}>
				<PartsRouter/>
			</div>
		</Page>
	)
}

StepperPages.propTypes = {
	classes: PropTypes.any,
}

export default StepperPages;
	
